(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fizzify-teaser-countdown"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('fizzify-countdown')) return;
  class FizzifyCountdown extends HTMLElement {
    static parseTarget(value) {
      const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})-06:00$/.exec(value || '');
      if (!match) return null;
      const [, year, month, day, hour, minute, second] = match.map(Number);
      if (month < 1 || month > 12 || day < 1 || day > new Date(Date.UTC(year, month, 0)).getUTCDate() || hour > 23 || minute > 59 || second > 59) return null;
      const target = Date.parse(value);
      return Number.isFinite(target) ? target : null;
    }
    static remaining(target, now) {
      let seconds = Math.max(0, Math.ceil((target - now) / 1000));
      return [Math.floor(seconds / 86400), Math.floor(seconds % 86400 / 3600), Math.floor(seconds % 3600 / 60), seconds % 60];
    }
    connectedCallback() {
      this.stop();
      this.clock = this.querySelector('[data-clock]');
      this.status = this.querySelector('[data-status]');
      this.parts = this.querySelectorAll('[data-value]');
      if (this.clock) this.clock.hidden = true;
      if (this.status) this.status.textContent = '';
      this.target = FizzifyCountdown.parseTarget(this.dataset.target);
      if (!this.clock || !this.status || this.parts.length !== 4 || this.target === null) return;
      this.tick();
      if (this.target > Date.now()) this.interval = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { this.stop(); }
    stop() { clearInterval(this.interval); this.interval = null; }
    tick() {
      const now = Date.now();
      const values = FizzifyCountdown.remaining(this.target, now);
      this.parts.forEach((element, index) => { element.textContent = String(values[index]).padStart(2, '0'); });
      this.clock.hidden = false;
      if (now >= this.target) {
        this.stop();
        this.clock.hidden = true;
        this.status.textContent = this.dataset.expired;
      }
    }
  }
  customElements.define('fizzify-countdown', FizzifyCountdown);
})();

  } catch(e) { console.error(e); }
})();
})();
